import { makeGrowerPath } from './utils';
import { get, post } from './client';

export function getProductivityForGrower(growerId) {
  return get(`/productivity/by-grower/${growerId}`);
}

export async function runProductivityPost(productivities) {
  const results = [];

  await productivities.reduce(async (lastRun, productivity) => {
    await lastRun;
    return post(makeGrowerPath(`/productivity/run`), productivity).then(
      (result) => results.push(result),
    );
  }, Promise.resolve());

  return results;
}

export function getProductivityStats(aaId) {
  return get(makeGrowerPath(`/productivity/stats/${aaId}/productivity`));
}

export function getNitrogenLossStats(aaId) {
  return get(makeGrowerPath(`/productivity/stats/${aaId}/nitrogen-loss`));
}

export function setProductivityApproval(aaId, isApproved) {
  return post(makeGrowerPath(`/productivity/approve/${aaId}`), { isApproved });
}
